import { handleFilterData } from "./helpers";
import { FilterFields } from "./interfaces";

export const filterDependencyArray: (data: any) => Array<FilterFields> = (data: any) => {
    return [
      {
        type: 'date',
        name: 'startDate',
        label: 'Start Date',
      },
      {
        type: 'date',
        name: 'endDate',
        label: 'End Date',
      },
      {
        type: 'select',
        name: 'mode',
        options: handleFilterData('mode', data),
        label: 'Event Type',
      },
      {
        type: 'select',
        name: 'duration',
        options: handleFilterData('duration', data),
        label: 'Duration',
      },
      {
        type: 'select',
        name: 'fee',
        options: handleFilterData('fee', data),
        label: 'Budget',
      },
    ];
  };
  